module.exports = __webpack_public_path__ + "assets/flyt-icons_area-pin.3974eda9.svg";